
angular.module('gallery').controller('galleryCtrl', ['Ads', 'galleryAnalytics', function (Ads, galleryAnalytics) { }]);







// WEBPACK FOOTER //
// ./assets/components/galleryPage/scripts/gallery/galleryController.js